class FilterBoxes extends HTMLElement {
  constructor() {
    super();

    this.toggleTab = this.toggleTab.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  connectedCallback() {
    // tabs
    this.bosFilterBoxTabs = this.querySelectorAll(".bosFilterBoxTab");
    if (this.bosFilterBoxTabs.length > 0) {
      this.bosFilterBoxTabs.forEach((tab) =>
        tab.addEventListener("click", this.toggleTab),
      );
    }

    // form buttons
    this.bosFilterBoxTabFiltersButton = this.querySelectorAll(
      ".bosFilterBoxTabFiltersButton",
    );
    if (this.bosFilterBoxTabFiltersButton.length > 0) {
      this.bosFilterBoxTabFiltersButton.forEach((button) => {
        button.addEventListener("click", this.handleFormSubmit);
      });
    }
  }

  disconnectedCallback() {
    // tabs
    if (this.bosFilterBoxTabs) {
      this.bosFilterBoxTabs.forEach((tab) =>
        tab.removeEventListener("click", this.toggleTab),
      );
    }
    // form buttons
    if (this.bosFilterBoxTabFiltersButton) {
      this.bosFilterBoxTabFiltersButton.forEach((button) => {
        button.removeEventListener("click", this.handleFormSubmit);
      });
    }
  }

  toggleTab(event) {
    const target = event.currentTarget;
    const dataBlockId = target.dataset.blockId;

    // stop all video
    this.stopVideos();
    // close all others
    this.hideElements();
    // open tabs with same data-id
    this.showMatchingElements(dataBlockId);
    // play video
    this.playVideo(dataBlockId);

    // handle svg display
    this.toggleSvgs(dataBlockId);

    // handle svg direction
    this.updateSvgDirections(dataBlockId);

    // handle presentation only tab
    this.updatePresentationTabVisibility(dataBlockId);
  }

  updatePresentationTabVisibility(id) {
    const tab = this.querySelector(".bosFilterPresentationBoxTab");
    if (!tab) return;
    const blockId = tab.dataset.blockId;
    const shouldHide = id === blockId;
    tab.classList.toggle("hideElement", shouldHide);
  }

  toggleSvgs(id) {
    // show other svgs
    const allTabSvgs = this.querySelectorAll(".bosFilterBoxTabSvg");
    if (allTabSvgs.length > 0) {
      allTabSvgs.forEach((svg) => svg.classList.remove("hideElement"));
    }

    // hide current svg
    const currentTabSvg = this.querySelector(
      `.bosFilterBoxTab[data-block-id="${id}"] .bosFilterBoxTabSvg`,
    );

    if (currentTabSvg) {
      currentTabSvg.classList.add("hideElement");
    }
  }

  updateSvgDirections(id) {
    const tabs = Array.from(this.querySelectorAll(".bosFilterBoxTab"));

    const activeIndex = tabs.findIndex((tab) => tab.dataset.blockId === id);

    const lastIndex = tabs.length - 1;

    tabs.forEach((tab, index) => {
      const svgWrapper = tab.querySelector(".bosFilterBoxTabSvg");
      if (!svgWrapper) return;

      svgWrapper.classList.remove("isLeft", "isRight", "isCurrent");

      // active
      if (index === activeIndex) {
        svgWrapper.classList.add("isCurrent");
        return;
      }

      // everything to the LEFT of active → point RIGHT (toward active)
      if (index < activeIndex) {
        svgWrapper.classList.add("isRight");
        return;
      }

      // everything to the RIGHT of active → point LEFT (toward active)
      if (index > activeIndex) {
        svgWrapper.classList.add("isLeft");
        return;
      }
    });
  }

  hideElements() {
    const bosFilterTabContent = this.querySelectorAll(".bosFilterTabContent");
    bosFilterTabContent.forEach((content) => content.classList.add("bosHidden"));
  }

  showMatchingElements(id) {
    const bosFilterTabContent = this.querySelector(
      `.bosFilterTabContent[data-block-id="${id}"]`,
    );
    if (bosFilterTabContent) {
      bosFilterTabContent.classList.remove("bosHidden");
    }
  }

  stopVideos() {
    const bosFilterBoxVideos = this.querySelectorAll(".bosFilterBoxVideo");
    if (bosFilterBoxVideos.length > 0) {
      bosFilterBoxVideos.forEach((boxVideo) => {
        const video = boxVideo.querySelector("video");
        if (video) {
          video.pause();
          video.currentTime = 0;
          video.load();
        }
      });
    }
  }

  playVideo(id) {
    const bosFilterBoxVideo = this.querySelector(
      `.bosFilterBoxVideo[data-block-id=${id}`,
    );
    if (bosFilterBoxVideo) {
      const video = bosFilterBoxVideo.querySelector("video");
      video?.play();
    }
  }

  handleFormSubmit(event) {
    event.preventDefault();

    // build query
    const searchParams = this.formQuryBuilder();
    if (searchParams) {
      window.location.href = `/collections/all?${searchParams}`;
    }
  }

  formQuryBuilder() {
    const params = new URLSearchParams();

    const checkedInputs = this.querySelectorAll(
      ".bosFilterBoxTabFilters input:checked",
    );
    checkedInputs.forEach((input) => {
      // filter.p.m.custom.region=highlands
      // filterName . filterFilter = value
      const key = `${input.dataset.filterName}.${input.dataset.filterFilter}`;
      const value = input.value.trim().replace(/\s+/g, "+");
      params.append(key, value);
    });

    return params.toString();
  }
}

if (!customElements.get("filter-boxes")) {
  customElements.define("filter-boxes", FilterBoxes);
}
